RA.Header = {
  init() {
    this.setVariables();
    this.bindEvents();

    this.initLoginLink();
  },
  setVariables() {
    this.$guestLoginLink = $("#guestLoginLink");
    this.$guestSignupLink  = $("#guestSignupLink");
    this.$profileButton = $("#profileButton");
    this.$profileMenu = this.$profileButton.next(".dropdown-menu");
    this.$langSelect = $("#language-selection-dropdown li a");
	this.$menuLinks = $("#mainNavCollapse ul li a");
  },
  bindEvents() {
    this.$langSelect.on("click.ra", this.languageChanged.bind(this));
    this.$profileButton.on("click.ra", this.profileButtonClicked.bind(this));
	this.$menuLinks.on("click.ra", this.menuLinkClicked.bind(this));
  },
  initLoginLink() {
    let prefix = location.search.length ? "&" : "?";
    let qs = location.search.replace(/%20/g, "+");
    qs = qs + prefix + "guest=0";
	qs = qs.replace(/&/g, "_amp_");

    let redirectTarget = encodeURIComponent(location.pathname + qs);
    let url = `${Config.contextPath}/${Config.portalInterface}/logout.jsp?redir=${redirectTarget}`;

    this.$guestLoginLink.attr("href", url);
    this.$guestSignupLink.attr("href", url);
  },
  languageChanged(e) {
    this.closeProfileMenu();

	let selectedLanguageCode = e.currentTarget.getAttribute("data-language");

    let url = `${Config.contextPath}/app/portlets/languagesettings/sessionbrowsercode.jsp`;
    let data = { code: selectedLanguageCode,
      SToken: Config.csrf.value
    };

    $.post(url, data)
      .done(() => window.location.reload());
  },
  profileButtonClicked(e) {
    let isOpen = this.$profileMenu.is(":visible");

    if (isOpen) {
      this.closeProfileMenu();
    } else {
      this.openProfileMenu();
    }
  },
  documentClicked(e) {
    let $target = $(e.target);
    let isChild = $target.closest(this.$profileMenu).length == 1;
    let isButton = $target.closest(this.$profileButton).length == 1;
    let isChildLink = isChild && $target.is("a");

    if (isButton || isChild) {
      if (!isChildLink) {
        return;
      }
    }

    this.closeProfileMenu();
  },
  openProfileMenu() {
    this.$profileMenu.show();
    this.$profileButton.attr("aria-expanded", true);
    this.$profileButton.addClass("-active");
    $(document).on("click.ra.profileMenu", this.documentClicked.bind(this));
  },
  closeProfileMenu() {
    this.$profileMenu.hide();
    this.$profileButton.attr("aria-expanded", false);
    this.$profileButton.removeClass("-active");
    $(document).off(".profileMenu");
  },
  menuLinkClicked() {
    var $menu = $("#mainNavCollapse");
	if ($menu.hasClass("in")) {
		$menu.removeClass("in");
		$menu.attr("aria-expanded", false);
	}
  }
}